// This is just an example,
// so you can safely delete all default props below

import forms from './forms.json';
import actions from './actions.json';
import cards from './cards.json';
import menus from './menus.json';
import specialties from './specialties.json';
import references from './references.json';
import errors from './errors.json';

export default {
  ...forms,
  ...actions,
  ...cards,
  ...menus,
  ...specialties,
  ...references,
  ...errors
};
